<template>
	<div class="empty-state">
		<div class="empty-state__content">
			<div class="empty-state__icon">
				<img class="empty-state__icon-image" src="@/assets/icons/not-found.svg" alt="No data" />
			</div>
			<h3 class="empty-state__title">{{errorMessage }}</h3>
		</div>
	</div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
	name: 'EmptyState',
  props: {
    errorMessage: {
      type: String,
      required: true,
    },
  },
});
</script>

<style scoped lang="scss">
.empty-state {
	display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
}

.empty-state__content {
	text-align: center;
	padding: 2rem;
}

.empty-state__icon-image {
	width: 40px;
	height: 40px;
}

.empty-state__title {
	color: #212529;;
}
</style>
